var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ServicePageLayout',{attrs:{"title":"Asset","subtitle":"รายการทรัพย์สิน","icon":"mdi-toy-brick-outline","breadcrumb":"Assets"}},[_c('v-card',{staticClass:"service-content-panel",attrs:{"flat":""}},[_c('v-card-text',[_c('ASSET_TABLE')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }